<template>
  <label
    class="check"
    :class="{
      'check--disabled': disabled,
      'check--error': errors.length,
      'check--checked': checked,
      'check--indeterminate': indeterminate,
    }"
  >
    <span class="check__state">
      <template>
        <!--        <IconComponent v-if="!checked" name="subtract-line" />-->
        <IconComponent v-if="checked" name="check-line" />
      </template>
    </span>
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      :indeterminate="indeterminate"
      @change="$emit('change', $event.target.checked)"
    />
    <slot />
  </label>
</template>

<script>
import IconComponent from "@/components/IconComponent.vue";

export default {
  name: "CheckboxComponent",
  components: { IconComponent },
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    checked: Boolean,
    disabled: Boolean,
    indeterminate: Boolean,
  },
};
</script>

<style lang="stylus">
.check {
  display flex
  gap 10px
  position relative
  cursor pointer
  align-items: center;
  text-align: left;
  user-select none
  font-weight: 400;
  font-size: 1em;
  line-height: 1em;
  letter-spacing: -0.02em;
  color: var(--dark)

  input {
    absolute left top
    visibility hidden
  }

  &--error {
    color var(--red) !important

    & .check__state {
      border-color var(--red) !important
    }
  }

  &--disabled {
    cursor not-allowed

    svg path {
      fill var(--dark_light_o15) !important
      stroke var(--white) !important
    }

    & .check__state {
      figure {
        border-radius 3px
        border: 1px solid var(--dark_light) !important;
        background var(--dark_light) !important
      }
    }


    &.check--indeterminate
    &.check--checked {
      & .check__state {
        background: var(--blue-500);
        border: 1px solid var(--blue-500);
      }
    }
  }

  &--indeterminate:not(&.check--disabled)
  &--checked:not(&.check--disabled) {
    color var(--black)

    & .check__state {
      background var(--yellow)
      border-color var(--yellow)

      svg path {
        fill var(--white)
      }
    }
  }

  &__state {
    width 28px
    height 28px
    background: var(--white);
    border: 1px solid var(--gray-3);
    border-radius: 5px;
    display flex
    align-items center
    justify-content center
    flex-shrink 0
    transition var(--transition)

    +below(1024px) {
      width: 20px;
      height: 20px;
    }

    .icon {
      width 28px
      height 28px
      display flex
      align-items center
      justify-content center

      svg path {
        transition var(--transition)
        fill var(--white)

      }
    }
  }
}
</style>
